/*
 * Copyright © 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */
import {IComponentOptions} from 'angular';
import {TSVersicherungsbeitragStatus} from '../../../models/enums/TSVersicherungsbeitragStatus';

require('./dv-versicherung-navigation.scss');
let template = require('./dv-versicherung-navigation.html');

export class DvVersicherungNavigationComponentConfig implements IComponentOptions {
    transclude = true;
    bindings: any = {
        versBeitragId: '@',
        title: '@?',
        status: '@',
        sticky: '<'
    };
    template = template;
    controller = DvVersicherungNavigationController;
    controllerAs = 'vm';
}

export class DvVersicherungNavigationController {
    static $inject: string[] = [];
    versBeitragId: string;
    status: TSVersicherungsbeitragStatus;
    sticky: boolean;

    constructor() {
    }

    $onInit() {

    }

    private isInBearbeitung(): boolean {
        return this.status !== TSVersicherungsbeitragStatus.NEU;

    }

}



// WEBPACK FOOTER //
// ./src/app/core/component/dv-versicherung-navigation/dv-versicherung-navigation.ts